import { array, defineAction, enumerated, object, string, number } from '~/prix'
import variableItemsExportAction from './variableItemsExport.action.json' with { type: 'json' }
import { variable } from '~/prix/types/presets/variable'

const variableItemsExportDefinition = defineAction({
  ...variableItemsExportAction,
  input: object({
    format: enumerated({
      xlsx: 'xlsx',
      csv: 'csv',
    }),
    variable,
    filter: object({}).isOptional(),
    highlight: object({}).isOptional(),
    space: object({}).isOptional(),
    time: object({}).isOptional(),
    select: array(string()).isOptional(),
    maxItems: number().isOptional(),
  }),
  output: object({}),
})

export default variableItemsExportDefinition

